'use client';

import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import HeroSection from './HeroSection';
import TrustIndicators from './TrustIndicators';
import FeaturedServices from './FeaturedServices';
import SocialProof from './SocialProof';
import QuickActions from './QuickActions';
import Footer from './Footer';

interface SearchFilters {
  brand: string;
  location: string;
  service: string;
}

const HomeInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const router = useRouter();

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleSearch = (filters: SearchFilters) => {
    if (!isHydrated) return;

    const params = new URLSearchParams();
    if (filters.brand) params.append('brand', filters.brand);
    if (filters.location) params.append('location', filters.location);
    if (filters.service) params.append('service', filters.service);

    router.push(`/search-results?${params.toString()}`);
  };

  return (
    <div className="min-h-screen bg-background">
      <HeroSection onSearch={handleSearch} />
      {/* <TrustIndicators /> */}
      <FeaturedServices />
      {/* <SocialProof /> */}
      <QuickActions />
      <Footer />
    </div>
  );
};

export default HomeInteractive;